module.exports = __webpack_public_path__ + "img/9788960174191.a110bae1.jpg";